// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomTxCardFieldDefinitionsCardCreate from './data'

export default function DataVaxiomTxCardFieldDefinitionsCardCreateFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsCardCreate">
      <DataVaxiomTxCardFieldDefinitionsCardCreate {...props}>
        {children}
      </DataVaxiomTxCardFieldDefinitionsCardCreate>
    </Flow>
  )
}
